export default "__VITE_PUBLIC_ASSET__7ff67b6a__"